import { gql, useMutation } from '@apollo/client'
import { NotificationTokenMutation, NotificationTokenMutationVariables } from 'types/graphql'

export const createNotificationTokenQuery = gql`
  mutation NotificationToken {
    createNotificationToken {
      success
      payload
    }
  }
`

export const useCreateNotificationToken = (onCompleted?: (data: NotificationTokenMutation) => void) => {
  return useMutation<NotificationTokenMutation, NotificationTokenMutationVariables>(createNotificationTokenQuery, { onCompleted })
}
